import { useState, useCallback } from 'react';

export const useToggleModalWithData = ({
  initialData = null,
  initialOpen = false,
}) => {
  const [data, setData] = useState(initialData);
  const [open, setOpen] = useState(initialOpen);

  const handleOpen = useCallback((newData, delay) => {
    setData(newData);

    setTimeout(() => {
      setOpen(true);
    }, delay);
  }, []);

  const handleClose = useCallback(
    (delay = 500) => {
      setOpen(false);

      setTimeout(() => {
        setData(initialData);
      }, delay);
    },
    [initialData],
  );

  return [open, data, handleOpen, handleClose];
};
